import React, {Component} from 'react';

// Reuses the shared `.stat-card` component (src/styles/components/_stat-card.scss),
// same as the Workflow Dashboard. Status → colour class: added=approved(green),
// removed=rejected(red), modified=pending(orange), identical=ignored(grey).
// Clicking a card filters the object list below to that status (toggle off with
// a second click); the active card carries `.stat-card-active`.
const STAT_CARDS = [
  {key: 'objectsAdded', label: 'Added', cls: 'approved', testid: 'sc-stat-added', status: 'ADDED'},
  {key: 'objectsRemoved', label: 'Removed', cls: 'rejected', testid: 'sc-stat-removed', status: 'REMOVED'},
  {key: 'objectsModified', label: 'Modified', cls: 'pending', testid: 'sc-stat-modified', status: 'MODIFIED'},
  {key: 'objectsIdentical', label: 'Identical', cls: 'ignored', testid: 'sc-stat-identical', status: 'IDENTICAL'},
];

class DiffSummaryBar extends Component {
  render() {
    const {stats, statusFilter, onStatusFilterChange} = this.props;
    const s = stats || {};

    return (
      <div className="sc-summary-bar" data-testid="sc-summary-bar">
        <div className="sc-stat-cards">
          {STAT_CARDS.map((c) => {
            const active = statusFilter === c.status;
            return (
              <div key={c.key} className="sc-stat-tile-wrapper">
                <div
                  className={`stat-card ${c.cls}${active ? ' stat-card-active' : ''}`}
                  data-testid={c.testid}
                  role="button"
                  tabIndex={0}
                  aria-pressed={active}
                  onClick={() => onStatusFilterChange(c.status)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      onStatusFilterChange(c.status);
                    }
                  }}
                >
                  <div className="stat-label">{c.label}</div>
                  {/* eslint-disable-next-line security/detect-object-injection -- c.key is a fixed literal from STAT_CARDS */}
                  <div className="stat-value">{s[c.key] || 0}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default DiffSummaryBar;
